import { CLEAN_STATE } from '../sagas/actions';
import problemsTypesMap from '../commons/ProblemsTypesMap';

export const SET_COORDINATES_PROBLEMS = 'SET_COORDINATES_PROBLEMS';
export const SET_COORDINATE_RESULT = 'SET_COORDINATE_RESULT';
export const SET_PROBLEMS_EMPTY_STATE = 'SET_PROBLEMS_EMPTY_STATE';
export const SET_RESULT_EMPTY_STATE = 'SET_RESULT_EMPTY_STATE';
export const SET_DOWNLOAD_FAILURE = 'SET_DOWNLOAD_FAILURE';
export const ADD_COORDINATES_SUCCESS = 'ADD_COORDINATES_SUCCESS';
export const SET_DATA_LOADING = 'SET_DATA_LOADING';
export const CLEAN_PROBLEMS_DATA = 'CLEAN_PROBLEMS_DATA';
export const ADD_COORDINATES_FAILURE = 'ADD_COORDINATES_FAILURE';

const initialState = {
  coordinatesProblems: [],
  dailyInfo: [],
  problemsStats: [],
  coordinatesProblemsError: null,
  coordinateResultError: null,
  loading: false
};

const upaDataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_COORDINATES_PROBLEMS: {
      return setCoordinatesProblems(state, payload);
    }
    case SET_COORDINATE_RESULT: {
      return setCoordinateResult(state, payload);
    }
    case SET_PROBLEMS_EMPTY_STATE: {
      return { ...state, coordinatesProblemsError: payload };
    }
    case SET_RESULT_EMPTY_STATE: {
      return { ...state, coordinateResultError: payload };
    }
    case SET_DOWNLOAD_FAILURE: {
      return { ...state, downloadProblemsError: payload };
    }
    case ADD_COORDINATES_SUCCESS: {
      return addCoordinateProblems(state, payload);
    }
    case ADD_COORDINATES_FAILURE: {
      return { ...state, coordinatesProblemsError: payload };
    }
    case SET_DATA_LOADING: {
      return { ...state, loading: payload };
    }
    case CLEAN_PROBLEMS_DATA: {
      return { ...state, coordinatesProblems: [], dailyInfo: [], problemsStats: [] };
    }
    case CLEAN_STATE: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default upaDataReducer;

const setCoordinatesProblems = (state, payload) => {
  return {
    ...state,
    coordinatesProblems: payload.problems,
    dailyInfo: payload.dailyInfo,
    problemsStats: payload.problemsStats.map(problem => {
      problem.name = problemsTypesMap[problem.id];
      problem.rate = +(problem.rate * 100).toFixed(2);
      return problem;
    })
  };
};

const addCoordinateProblems = (state, payload) => {
  return {
    ...state,
    coordinatesProblems: [ ...state.coordinatesProblems, ...payload ],
    coordinatesProblemsError: null
  };
};

const setCoordinateResult = (state, payload) => {
  const newState = { ...state, coordinateResultError: null };
  newState.coordinatesProblems.forEach(element => {
    if (element.serial === payload.result.serial && element.createdDate === payload.result.createdDate) {
      element.result = payload.result;
    }
  });
  return newState;
};


// WEBPACK FOOTER //
// ./src/reducers/upa-data.js